import { logErrorToConsole } from '../constants';
import HotelAmenitiesFilter from '../constants/HotelAmenitiesFilter';

const cleanseAmenities = (amenities) => {
  try {
    return (amenities || []).filter(
      (amenity) => !HotelAmenitiesFilter.some((str) => amenity.includes(str)),
    );
  } catch (error) {
    logErrorToConsole('Error cleansing amenities:', error);
    return [];
  }
};

export default cleanseAmenities;
